function BigTiles() {
	this.build();
}

BigTiles.prototype.build = function () {
	const that = this;
	this.items = $('.big-tiles .tile');
	this.reception = document.querySelector('.big-tiles .background.reception');
	this.lodging = document.querySelector('.big-tiles .background.lodging');
	this.outdoor = document.querySelector('.big-tiles .background.outdoor');
	this.items.on('mouseenter', function () {
		that.items.removeClass('active');
		this.classList.add('active');
		that.reception.classList.remove('active');
		that.lodging.classList.remove('active');
		that.outdoor.classList.remove('active');
		document.querySelector('.big-tiles .background.' + this.dataset.tile).classList.add('active');
	});
};
